<h2 mat-dialog-title>{{ data.title }}</h2>
<p style="margin-left: 20px;">User Choosen (Area / Block No / Qtr No) - {{ data.event.areaName + ' / '+ data.event.location }}</p>
<mat-dialog-content>
  <div *ngIf="data.type === 'APPROVAL'">
    <div style="margin-top: 10px; text-align: center;">
      <strong>Choose the location to Approve : </strong>
      <mat-form-field appearance="outline">
        <mat-label>Area Name</mat-label>
        <mat-select [(ngModel)]="areaId" (selectionChange)="onAreaSelect()">
          <mat-option *ngFor="let area of data.areas" [value]="area.code">
            {{ area.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 400px; margin-left: 10px;" *ngIf="dataSource.data.length > 0">
          <mat-label>Search locations...</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Location name, code, block, qtr etc...">
      </mat-form-field>
    </div>
    <div>
      <div>
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="locationCode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Code </th>
                <td mat-cell *matCellDef="let element"> {{ element.locationCode }} </td>
            </ng-container>

            <ng-container matColumnDef="locationName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Name </th>
                <td mat-cell *matCellDef="let element"> {{ element.locationName }} </td>
            </ng-container>

            <ng-container matColumnDef="quarterNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Quarter No </th>
                <td mat-cell *matCellDef="let element"> {{ element.quarterNumber }} </td>
            </ng-container>

            <ng-container matColumnDef="blockNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Block No </th>
              <td mat-cell *matCellDef="let element"> {{ element.blockNumber }} </td>
            </ng-container>

            <ng-container matColumnDef="residentName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Current Resident </th>
              <td mat-cell *matCellDef="let element"> {{ (element.rank + ' ' + element.residentFirstName + ' ' + element.residentLastName).trim() }} </td>
            </ng-container>

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef> Choose One </th>
                <td mat-cell *matCellDef="let element">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckboxChange(element)"
                        [checked]="selection.isSelected(element)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator
          [length]="dataSource.data.length" 
          [pageSize]="5" 
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons>
        </mat-paginator>
    </div>
    </div>
  </div>
  <div *ngIf="data.type === 'VIEW'">
    <span>
      <p>
        <strong>User Details</strong>
      </p>
      <p>
        Resident Name : {{ data.event.residentName }}
      </p>
      <p>
        Username : {{ data.event.userName }}
      </p>
      <p>
        Mobile Number : {{ data.event.mobileNumber }}
      </p>
      <p>
        Email : {{ data.event.emailAddress }}
      </p>
      <p>
        Approved Area : {{ data.event.approvedArea }}
      </p>
      <p>
        Approved Block No : {{ data.event.approvedBlockNo }}
      </p>
      <p>
        Approved Qtr No : {{ data.event.approvedQtrNo }}
      </p>
    </span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" *ngIf="data.type === 'VIEW'">
  <button mat-stroked-button (click)="onNoClick()">Back</button>
  <button mat-flat-button [mat-dialog-close]="event()">Okay</button>
</mat-dialog-actions>
<mat-dialog-actions align="center" *ngIf="data.type === 'APPROVAL'">
  <button mat-stroked-button (click)="onNoClick()">Back</button>
  <button mat-flat-button [mat-dialog-close]="event()" [disabled]="!locationSelected" (click)="onApproved()">Approve</button>
</mat-dialog-actions>